/* eslint-disable react/prop-types */
import PathMap from '../lib/PathMap'
import Footer from './Footer'
import Nav from './Nav'

function Layout ({ children, LeftBar, paths = [] }) {
  return (
    <div className={` w-screen h-screen grid grid-cols-20 grid-rows-20`}>
      <Nav />
      {LeftBar != undefined && LeftBar}
      <div
        className={` p-2 bg-color1 row-span-18 ${
          LeftBar == undefined ? ' col-span-20' : 'col-span-17'
        } `}
      >
        <PathMap paths={paths} />
        <div className=' w-full h-full py-4 overflow-y-auto'>{children}</div>
      </div>
      <Footer />
    </div>
  )
}

export default Layout
